<template>
    <v-dialog>
        <template #activator="{on}">
            <v-btn v-on="on">Handling List</v-btn>
        </template>
        <v-card v-if="handling">
            <v-toolbar elevation="0">
                Handling List
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col>
                        <pdf-viewer
                            url="handling/download"
                            :params="{ id: handling.id }"
                            :filename="'handling_list_'+handling.id+'.pdf'"
                            style="width: 300%"
                        ></pdf-viewer>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import PdfViewer from '../../PdfViewer.vue';
export default {
    components: {PdfViewer},
    props: {
        handling:{
            type:Object,
            required: true
        }
    }
}
</script>